export default __webpack_public_path__ + "static/media/MYP.af6b3dfb.jpeg";